/**
 * @generated SignedSource<<299fc607a2bd55b9ef701327d2266aca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UpdateCategoryMutationResponse",
    "kind": "LinkedField",
    "name": "updateCategoryMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCategoryMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateCategoryMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e5390951a9ebd9391050d044613b6a7c",
    "id": null,
    "metadata": {},
    "name": "UpdateCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCategoryMutation(\n  $id: ID\n  $description: String\n) {\n  updateCategoryMutation(id: $id, description: $description) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "bbc94cbec9624f5583b65d7142315743";

module.exports = node;
